import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'approve.tooltip.title',
        defaultMessage: 'You have a new transaction to confirm',
    },
    fromCard: {
        id: 'approve.tooltip.text',
        defaultMessage: 'from card ••{numbers}',
    },
    view: {
        id: 'approve.tooltip.view',
        defaultMessage: 'View',
    },
})
